import { 
    LOAD_LIST_USER, LOAD_A_USER, ADD_NEW_USER, UPDATE_A_USER, DELETE_A_USER, 
    CLEAR_USER_ACTION_STATUS, CLEAR_A_USER_DETAIL,
} from '../actionTypes';
import { SUCCESS_STATUS, FAILED_STATUS } from '../../constants';

const initialState = {
    userList: [],
    userDetail: null,
    loading: false,
    error: '',
    actionStatus: undefined,
    actionMsg: "",
};

export default function(state = initialState, action) {
    switch(action.type) {
        case LOAD_LIST_USER: {
            return {
                ...state,
                userList: action.payload,
            }
        }

        case LOAD_A_USER: {
            return {
                ...state,
                userDetail: action.payload
            }
        }

        case ADD_NEW_USER: {
            if(!action.payload || action.payload && !action.payload.data) return { 
                ...state,
                actionStatus: FAILED_STATUS,
                error: action.payload?.msg
            };

            return {
                ...state,
                loading: false,
                userList: [
                    action.payload.data,
                    ...state.userList
                ],
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }

        case UPDATE_A_USER: {
            if(!action.payload || action.payload && !action.payload.data) return { 
                ...state,
                actionStatus: FAILED_STATUS,
                error: action.payload?.msg
            };

            return {
                ...state,
                loading: false,
                userList: state.userList.map(item => item.id !== action.payload.data.id ? item : action.payload.data),
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }

        case DELETE_A_USER: {
            if(!action.payload || action.payload && !action.payload.data) return { 
                ...state,
                actionStatus: FAILED_STATUS,
                error: action.payload?.msg
            };
            
            return {
                ...state,
                loading: false,
                userList: state.userList.filter(item => item.id !== parseFloat(action.payload.data)),
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }

        case CLEAR_A_USER_DETAIL: {
            return {
                ...state,
                userDetail: null,
            }
        }

        case CLEAR_USER_ACTION_STATUS: {
            return {
                ...state,
                actionStatus: undefined,
                actionMsg: ""
            }
        }

        default:
            return state;
    }
}